/** Notification sounds for chat events. */

function isMuted(): boolean {
  if (typeof window === 'undefined') return true
  return localStorage.getItem('monarch.sounds_muted') === 'true'
}

/** Play the ping sound when the user sends a message. */
export function playSendSound(): void {
  if (isMuted()) return
  try {
    const audio = new Audio('/sounds/ping.mp3')
    audio.volume = 0.3
    audio.play().catch(() => {})
  } catch {
    // Audio not available
  }
}

/** Play the ping sound when the assistant starts responding. */
export function playReceiveSound(): void {
  if (isMuted()) return
  try {
    const audio = new Audio('/sounds/ping.mp3')
    audio.volume = 0.5
    audio.play().catch(() => {})
  } catch {
    // Audio not available
  }
}
